import { minute, hour, day, addSeconds, addMonths, month, year, create } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Date.js";
import { padLeft, printf, toText } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/String.js";
import { op_UnaryNegation, op_Multiply, toNumber, fromParts, compare } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Decimal.js";
import { int32ToString } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Util.js";

export function monatName(_arg) {
    switch (_arg) {
        case 1:
            return "Januar";
        case 2:
            return "Februar";
        case 3:
            return "März";
        case 4:
            return "April";
        case 5:
            return "Mai";
        case 6:
            return "Juni";
        case 7:
            return "Juli";
        case 8:
            return "August";
        case 9:
            return "September";
        case 10:
            return "Oktober";
        case 11:
            return "November";
        case 12:
            return "Dezember";
        default:
            return "";
    }
}

export function getMonthStartAndEnd(date) {
    let copyOfStruct;
    const first = create(year(date), month(date), 1, 0, 0, 0);
    return [first, (copyOfStruct = addMonths(first, 1), addSeconds(copyOfStruct, -1))];
}

export function asString(date) {
    const arg = day(date) | 0;
    const arg_1 = month(date) | 0;
    const arg_2 = year(date) | 0;
    return toText(printf("%02i.%02i.%04i"))(arg)(arg_1)(arg_2);
}

export function asStringWithTime(date) {
    const arg = day(date) | 0;
    const arg_1 = month(date) | 0;
    const arg_2 = year(date) | 0;
    const arg_3 = hour(date) | 0;
    const arg_4 = minute(date) | 0;
    return toText(printf("%02i.%02i.%04i %02i:%02i Uhr"))(arg)(arg_1)(arg_2)(arg_3)(arg_4);
}

export function asLongString(date) {
    const arg = day(date) | 0;
    const arg_1 = monatName(month(date));
    const arg_2 = year(date) | 0;
    return toText(printf("%i. %s %04i"))(arg)(arg_1)(arg_2);
}

export function asMonatJahr(date) {
    const arg = monatName(month(date));
    const arg_1 = year(date) | 0;
    return toText(printf("%s %04i"))(arg)(arg_1);
}

function asMoney2(einheit, v) {
    let copyOfStruct;
    const patternInput = (compare(v, fromParts(0, 0, 0, false, 0)) < 0) ? [~~toNumber(op_Multiply(op_UnaryNegation(v), fromParts(100, 0, 0, false, 0))), "-"] : [~~toNumber(op_Multiply(v, fromParts(100, 0, 0, false, 0))), ""];
    const vInt = patternInput[0] | 0;
    const nachkomma = padLeft((copyOfStruct = (vInt % 100), int32ToString(copyOfStruct)), 2, "0");
    const split = (v_1) => {
        let copyOfStruct_1;
        if (v_1 < 1000) {
            return int32ToString(v_1);
        }
        else {
            const v_2 = v_1 | 0;
            const arg = split(~~(v_2 / 1000));
            const arg_1 = padLeft((copyOfStruct_1 = (v_2 % 1000), int32ToString(copyOfStruct_1)), 3, "0");
            return toText(printf("%s.%s"))(arg)(arg_1);
        }
    };
    const vorkomma = split(~~(vInt / 100));
    return toText(printf("%s%s,%s%s"))(patternInput[1])(vorkomma)(nachkomma)(einheit);
}

export const asMoney = (v) => asMoney2(" €", v);

export const asMoneyEur = (v) => asMoney2(" EUR", v);

export const asHtmlMoney = (v) => asMoney2("&nbsp;€", v);

function asMoney2float(einheit, v) {
    let copyOfStruct;
    const patternInput = (v < 0) ? [~~(-v * 100), "-"] : [~~(v * 100), ""];
    const vInt = patternInput[0] | 0;
    const nachkomma = padLeft((copyOfStruct = (vInt % 100), int32ToString(copyOfStruct)), 2, "0");
    const split = (v_1) => {
        let copyOfStruct_1;
        if (v_1 < 1000) {
            return int32ToString(v_1);
        }
        else {
            const v_2 = v_1 | 0;
            const arg = split(~~(v_2 / 1000));
            const arg_1 = padLeft((copyOfStruct_1 = (v_2 % 1000), int32ToString(copyOfStruct_1)), 3, "0");
            return toText(printf("%s.%s"))(arg)(arg_1);
        }
    };
    const vorkomma = split(~~(vInt / 100));
    return toText(printf("%s%s,%s%s"))(patternInput[1])(vorkomma)(nachkomma)(einheit);
}

export const asMoneyFloat = (v) => asMoney2float(" €", v);

//# sourceMappingURL=Shared.fs.js.map
